import { Layout } from '../components/Layout';
import styles from './HomePage.module.css';

export default function HomePage() {
  const chromeStoreUrl = import.meta.env.VITE_CHROME_STORE_URL || 'https://chromewebstore.google.com/detail/rad-sbc-auto-solver/jckepdlfmmmncmgnnndkajnfkhpliedn';

  return (
    <Layout>

      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            Solve FC Ultimate Team SBCs
            <span className={styles.heroGradient}> Automatically</span>
          </h1>
          <p className={styles.heroSubtitle}>
            Stop wasting coins on expensive players. Our Chrome extension finds the cheapest squad combinations from your club for any SBC.
          </p>
          <div className={styles.heroCta}>
            <a href={chromeStoreUrl} target="_blank" rel="noopener noreferrer" className={styles.primaryButton}>
              Download Extension
            </a>
            <a href="#how-it-works" className={styles.secondaryButton}>
              See How It Works
            </a>
            <a href="https://discord.gg/38vAvKqH" target="_blank" rel="noopener noreferrer" className={styles.secondaryButton}>
              Join Discord Support
            </a>
          </div>
        </div>
      </section>

      <section id="features" className={styles.features}>
        <h2 className={styles.sectionTitle}>Features</h2>
        <div className={styles.featureGrid}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>⚡</div>
            <h3>Fast & Reliable</h3>
            <p>Most SBCs solved in seconds, complex ones in under 30 seconds</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>💰</div>
            <h3>Cheapest Solutions</h3>
            <p>Find the most cost-effective squad combinations from your club</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🎯</div>
            <h3>Smart Matching</h3>
            <p>Automatically handles chemistry, rating, and all SBC requirements</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🔄</div>
            <h3>One-Click Apply</h3>
            <p>Automatically fills your squad with the solution</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🔒</div>
            <h3>Secure & Private</h3>
            <p>Your FC credentials never leaves your browser</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🌐</div>
            <h3>Works Everywhere</h3>
            <p>Compatible with Chrome, Edge, Brave, and all Chromium-based browsers</p>
          </div>
        </div>
      </section>

      <section id="how-it-works" className={styles.howItWorks}>
        <h2 className={styles.sectionTitle}>How It Works</h2>
        <div className={styles.steps}>
          <div className={styles.step}>
            <div className={styles.stepNumber}>1</div>
            <h3>Install Extension</h3>
            <p>Download and install the extension for Chrome, Edge, Brave, or any Chromium browser</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>2</div>
            <h3>Open Any SBC</h3>
            <p>Navigate to any SBC in EA FC Ultimate Team Web App</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>3</div>
            <h3>Click Solve</h3>
            <p>Click the "Auto Solve SBC" button that appears</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>4</div>
            <h3>Done!</h3>
            <p>Watch as the extension automatically fills the squad</p>
          </div>
        </div>
      </section>

      <section id="download" className={styles.cta}>
        <h2>Ready to solve SBCs smarter?</h2>
        <p>Download the extension for Chrome, Edge, Brave, or any Chromium browser and start saving coins today</p>
        <a href={chromeStoreUrl} target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>Download Now</a>
      </section>

    </Layout>
  );
}
